module.exports = __webpack_public_path__ + "static/media/icon-copy.3b1d9211.svg";